import React from "react";
import { TextField } from "@mui/material";
import { SearchIcon } from "lucide-react";
import BrandBox from "./Components/BrandBox";
import Categoryheader2 from "./Components/LocationHeader";
import { Permissions } from "../../../permissions";

const Location = () => {
  let createlocation =
    Permissions.find(permission => permission.includes("create_location")) !==
    undefined;
  return (
    <div className=" bg-white ml-[2.083333vw] mt-[3.5185vh] mr-[2.638888vw] h-[85vh] overflow-y-scroll customScrollBar no-scrollbar">
      <div className="flex flex-row box-border h-[8.7vh] w-[100]">
        <div className="w-[70%] h-[100% box-border flex items-center px-[3.220338983%] justify-start text-[3vh] font-medium font-outfit">
          Location
        </div>
        <div className="w-[30%] h-[100%] mt-3 box-border flex flex-row items-start justify-end mx-4">
          <div className="bg-[#F5F6F8] rounded-lg flex w-[100%] flex-row items-center border border-grey-400 h-[65%] allProductSearchBoxContainer">
            <SearchIcon className=" mx-2 w-[20px] h-[20px]" color="#83899F" />
            <input
              type="text"
              placeholder="Search by ID, Name..."
              className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
            />
          </div>
        </div>
      </div>

      <Categoryheader2 />

      <div className="grid grid-cols-4 gap-4 mt-10 h-[38.8888888vh] overflow-y-scroll overflow-x-hidden customScrollBar px-2">
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
        <BrandBox />
      </div>

      <div className="flex flex-row box-border h-[8.7vh] w-[100] mt-3">
        <div className="w-[70%] box-border flex items-center px-[3.220338983%] justify-start text-[3vh] font-medium font-outfit">
          Add Location
        </div>
      </div>

      <div className="flex flex-row items-start justify-start gap-x-4 box-border ml-[2.083333vw]">
        <TextField
          id="outlined-basic"
          label="City"
          variant="outlined"
          size="small"
        />
        <TextField
          id="outlined-basic"
          label="State"
          variant="outlined"
          size="small"
        />
      </div>

      <div className="flex flex-row mt-9 items-start justify-start mx-[2.522222vw] gap-x-3 pb-8">
        <button className="border-2 border-purple-700 rounded-md px-5 py-2 text-[2.23755vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
          {" "}
          <span className="px- text-[#5652B0] px-3">Cancel</span>
        </button>
        {createlocation ? (
          <button className="border-2 border-purple-700 rounded-md px-9 py-2 text-[2.23755vh] font-medium font-outfit flex items-center justify-center flex-row bg-[#5652B0]">
            {" "}
            <span className="px-2 text-white ">Save</span>
          </button>
        ) : (
          <button className="border-2 border-[#acacacCC] rounded-md px-9 py-2 text-[2.23755vh] font-medium font-outfit flex items-center justify-center flex-row bg-[#acacacCC]">
            {" "}
            <span className="px-2 text-white ">Save</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Location;
